import BookPage from '../components/Book/Book';

export default function Book() {
  return <BookPage />;
}
